<template>
  <div class="results-page min-h-[100vh]">
    <AllResultsWrapper />
  </div>
</template>

<script>
import AllResultsWrapper from '@/wrappers/AllResultsWrapper.vue';

export default {
  name: "AllResultsPage",
  components: {
    AllResultsWrapper,
  },
};
</script>